import services from './../../services/service'; // Service Class
let service = new services();

export default {
    name: "Sidebar",
    data() {
        return {
            forums: {},
            forum: {},
            search: {},
            survey: {},
            surveys: [],
            pageNotSurvey: true,
            siteUrl:service.siteUrl+"?title=",
            cnproParentCategories:{},
            sub_categories: {}
        }
    },
    
    methods: {
        copyLink(survey) {
           this.$clipboard(this.siteUrl+survey.cnsurvey_title_url)
              var btn = $('.linky').tooltip({
                  trigger: 'click',
                  placement: 'bottom'
                });
              this.setTooltip(btn, 'Copied to Clipboard');
              this.hideTooltip(btn);
          },
          setTooltip(btn, message) {
              btn.tooltip('hide')
                .attr('data-original-title', message)
                .tooltip('show');
            },
            
          hideTooltip(btn) {
              setTimeout(function() {
                btn.tooltip('hide');
              }, 1000);
          },
        setForum(forum){
                localStorage.setItem("cn_f",forum);
                this.$router.push("/forum");
            },
        // Get all surveys
        getSurveys() {
            // service.allSurveys(this).then((res) => {
            service.getAllSurveys(this,0,1).then((res) => {
                this.surveys = res.body.data;
            })
        },
        getAllForums() {
            service.getAllForums(this).then(data => {
                if(data.body.status == 200) {
                    this.forums = data.body.data;
                }
            }).catch((err) => {
                if(err) {
                    //toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },
        checkCurrentPage(){
            if((this.$route.path != '/cnsurveys')){
                this.pageNotSurvey = true;
            }else{
                this.pageNotSurvey = false;
            }
        },

        /* pre searchers */
    getCnproParentCategories() {
        service.getCnproParentCategories(this).then(data => {
            if(data.body.status == 200) {
                this.cnproParentCategories = data.body.data;
            }
        }).catch((err) => {
            if(err) {
                //toastr.error('Sorry, could not process information', 'Warning!');
            }
        })
    },
    //cnpro sub categories
    getCnproSubCategories(parent){
        service.getCnproCategories(this,parent).then(data => {
            if(data.body.status == 200) {
                this.sub_categories = data.body.data;
               // document.getElementById("loader").style.visibility = "hidden";
            }
        }).catch((err) => {
            if(err) {
                //toastr.error('Sorry, could not process information', 'Warning!');
            }
        })
    },
    //businesses
    getBusinessCategories() {
        service.getBusinessCategories(this).then(data => {
            if(data.body.status == 200) {
                this.sub_categories = data.body.data;
            }
        }).catch((err) => {
            if(err) {
               // toastr.error('Sorry, could not process information', 'Warning!');
            }
        })
    },
    prep_sub_categories(parent){
        if(parent == "business-search"){
            this.search.type = 'business-search';
            this.getBusinessCategories()
        }
        else{
            this.search.type = 'cnpro-search';
            this.getCnproSubCategories(parent)
        }
    },
    prep_search(keywords){
        this.search.keywords = keywords
        this.search.city = 'Abuja'
    },
    /* pre searchers */
        doSearch(){
            var credentials = {
                search_type: this.search.type,
                search_keywords: this.search.keywords,
                search_city: this.search.city
            }

            let navi = this.$router;

            if(credentials.search_type != null || credentials.search_keywords != null) {
                navi.push(this.search.type+'?context='+this.search.keywords+'&city='+this.search.city);
                
           }else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        
        },
    },
    created: function(){
        this.getAllForums();
        this.getSurveys();
        this.checkCurrentPage();
        this.getCnproParentCategories();
    }
}


// WEBPACK FOOTER //
// ./src/components/Sidebar/script.js